<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{data.titulo}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div [innerHTML]="data.mensaje"></div>
        <br/>
        <br/>
        <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false" >
                <mat-expansion-panel-header>
                <mat-panel-title>
                    Detalles de error
                </mat-panel-title>
                <mat-panel-description>
                    Ver
                </mat-panel-description>
                </mat-expansion-panel-header>
                <p>{{data.stackTrace}}</p>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button mat-button class="save-button" (click)="matDialogRef.close()" aria-label="OK">
            Ok
        </button>

    </div>
</div>